import React, { Component } from "react";
import Input from "../../2/Controls/Input";

class CampaignDetailsStep extends Component {
  occurrenceOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly (Select Days)" },
    { value: "custom_days", label: "Every X Days" },
    { value: "monthly", label: "Monthly" },
  ];

  styles = {
    container: {
      padding: "0",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "600",
      color: "#4B5563",
      marginBottom: "24px",
    },
    gridContainer: {
      display: "grid",
      gap: "12px",
    },
    frequencySection: {
      marginBottom: "0",
    },
    label: {
      display: "block",
      fontSize: "16px",
      color: "#111827",
      marginBottom: "6px",
    },
    radioGroup: {
      display: "flex",
      gap: "16px",
    },
    radioLabel: {
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer",
    },
    radioInput: {
      marginRight: "8px",
    },
    radioSpan: {
      marginLeft: "8px",
    },
    fieldsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(1, 1fr)",
      gap: "40px",
      gapY: "16px",
      marginTop: "0",
    },
    daysContainer: {
      marginTop: "0",
    },
    daysLabel: {
      color: "#111827",
    },
    daysLabelError: {
      color: "#EF4444",
    },
    daysCheckboxGroup: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
      marginTop: "4px",
    },
    dayCheckboxLabel: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "16px",
      color: "#374151",
      marginRight: "8px",
      marginTop: "4px",
      cursor: "pointer",
    },
    dayCheckbox: {
      fontSize: "16px",
    },
    errorText: {
      color: "#EF4444",
      fontSize: "14px",
      marginTop: "4px",
    },
    customDaysContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "12px",
      maxWidth: "360px",
      gap: "8px",
    },
    customDaysLabel: {
      whiteSpace: "nowrap",
    },
    daysSpan: {
      marginLeft: "4px",
    },
    noteText: {
      fontSize: "12px",
      color: "#6B7280",
      marginTop: "4px",
    },
  };

  responsiveStyles = `
    @media (min-width: 640px) {
      .campaign-fields-grid {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }
    @media (min-width: 1280px) {
      .campaign-fields-grid {
        grid-template-columns: repeat(4, 1fr) !important;
      }
    }
  `;

  handleFrequencyChange = (value) => {
    const { updateFormData } = this.props;
    updateFormData("frequency", value);
    if (value === "One Time") {
      updateFormData("occurrence", "");
      updateFormData("days", []);
      updateFormData("interval", "");
      updateFormData("endDate", "");
    }
  };

  handleStartDateChange = (value) => {
    this.props.updateFormData("startDate", value);
  };

  handleEndDateChange = (value) => {
    this.props.updateFormData("endDate", value);
  };

  handleOffsetChange = (value) => {
    const numValue = Math.max(0, Number(value));
    this.props.updateFormData("offset", numValue);
  };

  handleSlotChange = (value) => {
    const { updateFormData } = this.props;
    const slotValue = Number(value);
    updateFormData("slot", slotValue);
    updateFormData("slotStart", slotValue);
    updateFormData("slotEnd", slotValue + 2);
  };

  handleOccurrenceChange = (value) => {
    this.props.updateFormData("occurrence", value);
  };

  handleDayCheckboxChange = (day, isChecked) => {
    const { formData, updateFormData } = this.props;
    const currentDays = formData && formData.hasOwnProperty('days') ? formData.days : [];
    const newDays = isChecked
      ? [...(currentDays || []), day]
      : (currentDays || []).filter((d) => d !== day);
    updateFormData("days", newDays);
  };

  handleIntervalChange = (value) => {
    this.props.updateFormData("interval", value);
  };

  renderFrequencySection = () => {
    const { formData, campaignType } = this.props;
    
    if (campaignType !== "promotional") return null;
    
    return (
      <div style={this.styles.frequencySection}>
        <label style={this.styles.label}>Frequency</label>
        <div style={this.styles.radioGroup}>
          <label style={this.styles.radioLabel}>
            <input
              type="radio"
              style={this.styles.radioInput}
              name="frequency"
              value="One Time"
              checked={formData && formData.hasOwnProperty('frequency') && formData.frequency === "One Time"}
              onChange={() => this.handleFrequencyChange("One Time")}
            />
            <span style={this.styles.radioSpan}>One-Time</span>
          </label>
          <label style={this.styles.radioLabel}>
            <input
              type="radio"
              style={this.styles.radioInput}
              name="frequency"
              value="Recurring"
              checked={formData && formData.hasOwnProperty('frequency') && formData.frequency === "Recurring"}
              onChange={() => this.handleFrequencyChange("Recurring")}
            />
            <span style={this.styles.radioSpan}>Recurring</span>
          </label>
        </div>
      </div>
    );
  };

  renderPromotionalFields = () => {
    const { formData, campaignType, errors } = this.props;
    
    if (campaignType !== "promotional") return null;
    
    const isOneTime = formData && formData.hasOwnProperty('frequency') && formData.frequency === "One Time";
    
    return (
      <>
        <Input
          type="date"
          label={isOneTime ? "Campaign Date" : "Start Date"}
          value={formData && formData.hasOwnProperty('startDate') ? formData.startDate : ''}
          onChange={this.handleStartDateChange}
          error={errors && errors.hasOwnProperty('startDate') ? errors.startDate : undefined}
        />
        {formData && formData.hasOwnProperty('frequency') && formData.frequency === "Recurring" && (
          <Input
            type="date"
            label="End Date"
            value={formData && formData.hasOwnProperty('endDate') ? formData.endDate : ''}
            onChange={this.handleEndDateChange}
            error={errors && errors.hasOwnProperty('endDate') ? errors.endDate : undefined}
          />
        )}
      </>
    );
  };

  renderOffsetField = () => {
    const { campaignType, formData, errors } = this.props;
    
    if (campaignType === "promotional") return null;
    
    return (
      <div>
        <Input
          type="number"
          label="Send Before (days)"
          placeholder="Enter number of days"
          value={formData && formData.hasOwnProperty('offset') ? formData.offset : ''}
          onChange={this.handleOffsetChange}
          error={errors && errors.hasOwnProperty('offset') ? errors.offset : undefined}
        />
        <p style={this.styles.noteText}>
          Note: 0 means message will be sent on the same day of {campaignType}.
        </p>
      </div>
    );
  };

  renderWeeklyDaysSelection = () => {
    const { formData, errors } = this.props;
    
    if (!(formData && formData.hasOwnProperty('occurrence') && formData.occurrence === "weekly")) return null;
    
    return (
      <div style={this.styles.daysContainer}>
        <label style={errors && errors.hasOwnProperty('days') ? this.styles.daysLabelError : this.styles.daysLabel}>
          Select Days:
        </label>
        <div style={this.styles.daysCheckboxGroup}>
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
            <label key={day} style={this.styles.dayCheckboxLabel}>
              <input
                type="checkbox"
                value={day}
                style={this.styles.dayCheckbox}
                checked={formData && formData.hasOwnProperty('days') && formData.days ? formData.days.includes(day) : false}
                onChange={(e) => this.handleDayCheckboxChange(day, e.target.checked)}
              />
              {day}
            </label>
          ))}
        </div>
        {errors && errors.hasOwnProperty('days') && <div style={this.styles.errorText}>{errors.days}</div>}
      </div>
    );
  };

  renderCustomDaysSelection = () => {
    const { formData, errors } = this.props;
    
    if (!(formData && formData.hasOwnProperty('occurrence') && formData.occurrence === "custom_days")) return null;
    
    return (
      <div style={this.styles.customDaysContainer}>
        <label style={this.styles.customDaysLabel}>Repeat Every:</label>
        <Input
          type="number"
          value={formData && formData.hasOwnProperty('interval') ? formData.interval : ''}
          onChange={this.handleIntervalChange}
          placeholder="e.g. 3"
          error={errors && errors.hasOwnProperty('interval') ? errors.interval : undefined}
        />
        <span style={this.styles.daysSpan}>Days</span>
      </div>
    );
  };

  render() {
    const { timeSlotOptions, formData, errors, campaignType } = this.props;

    // Convert timeSlotOptions to format expected by Input component for select
    const selectTimeSlotOptions = timeSlotOptions && timeSlotOptions.map ? timeSlotOptions.map(option => ({
      value: option.value,
      label: option.label
    })) : [];

    // Convert occurrenceOptions to format expected by Input component for select
    const selectOccurrenceOptions = this.occurrenceOptions.map(option => ({
      value: option.value,
      label: option.label
    }));

    const isOneTime = formData && formData.hasOwnProperty('frequency') && formData.frequency === "One Time";
    const showOccurrence = !(!(formData && formData.hasOwnProperty('frequency')) || formData.frequency === "One Time");

    return (
      <div style={this.styles.container}>
        <style>{this.responsiveStyles}</style>
        <h2 style={this.styles.heading}>Campaign Details</h2>
        <div style={this.styles.gridContainer}>
          {this.renderFrequencySection()}

          <div className="campaign-fields-grid" style={this.styles.fieldsGrid}>
            {this.renderPromotionalFields()}
            {this.renderOffsetField()}
            
            <Input
              type="select"
              label="Time Slot"
              value={formData && formData.hasOwnProperty('slot') ? String(formData.slot) : ''}
              onChange={this.handleSlotChange}
              error={errors && errors.hasOwnProperty('slot') ? errors.slot : undefined}
            >
              {selectTimeSlotOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>

            {showOccurrence && (
              <Input
                type="select"
                label="Occurrence"
                value={formData && formData.hasOwnProperty('occurrence') ? formData.occurrence : ''}
                onChange={this.handleOccurrenceChange}
                error={errors && errors.hasOwnProperty('occurrence') ? errors.occurrence : undefined}
              >
                {selectOccurrenceOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            )}
          </div>

          {this.renderWeeklyDaysSelection()}
          {this.renderCustomDaysSelection()}
        </div>
      </div>
    );
  }
}

export default CampaignDetailsStep;